import type { FaireProductEntity } from "../../entity_types/product";

export const p_82jxycvcxj: FaireProductEntity = {
  token: "p_82jxycvcxj",
  type: "product",
  name: "Vase, Newspaper",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/a512eb012eb113b41b23a2c53076ebe48201d44c617ce0c6854f6f90bd6cea58.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/643af0dbd36573d410f79886f3486eea8151d5ca392b81c506b7bee4ca59a04b.jpeg",
    "https://cdn.faire.com/fastly/a86b79a0c03b37db70d1e3e7c8ed7e705a8fff1f39fe027faeb1f01132679791.jpeg"
  ],
  priceDollars: 14,
  description: "Extra! Extra! Read all about it! This standout ceramic vase features a bold newspaper-inspired design topped off with the most perfect pink bow. Equal parts cheeky and charming, it’s ready to hold flowers, pens, or simply steal the spotlight on any shelf or table.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Ceramic vase with an eye-catching newspaper print\n• Finished with a sweet pink bow detail\n• Perfect for flowers, dried stems, or decorative display\n• Makes a fun statement on tables, desks, or bookshelves\n• Designed in Bando’s signature bright, whimsical style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and home décor boutiques\n• Lifestyle and stationery retailers\n• Home decorators, design lovers, and collectors of quirky ceramics\n• Wholesale buyers seeking unique, conversation-starting décor",
  tags: [],
  msrpDollars: 28.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:19.079Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
